const previewDisposers = new WeakMap<HTMLElement, () => void>();
function keepHistoryPreviewInViewport(): void {
  const preview = document.querySelector<HTMLImageElement>(".history-thumbnail-popover");
  if (!preview) return;
  const margin = 16;
  const bounds = preview.getBoundingClientRect();
  const left = Math.min(Math.max(margin, bounds.left), Math.max(margin, window.innerWidth - bounds.width - margin));
  const top = Math.min(Math.max(margin, bounds.top), Math.max(margin, window.innerHeight - bounds.height - margin));
  if (Math.abs(bounds.left - left) > 1) preview.style.left = `${left}px`;
  if (Math.abs(bounds.top - top) > 1) preview.style.top = `${top}px`;
}

export function scrollHistoryVisitIntoView(visitId: number): void {
  window.requestAnimationFrame(() => document.querySelector<HTMLElement>(`.history-visit[data-history-visit="${visitId}"]`)?.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" }));
}

export function installHistoryPreview(owner: HTMLElement): void {
  if (previewDisposers.has(owner)) return;
  let frame: number | undefined;
  const update = () => {
    if (frame !== undefined) return;
    frame = window.requestAnimationFrame(() => { frame = undefined; keepHistoryPreviewInViewport(); });
  };
  window.addEventListener("pointermove", update, { passive: true });
  window.addEventListener("resize", update);
  previewDisposers.set(owner, () => {
    window.removeEventListener("pointermove", update); window.removeEventListener("resize", update);
    if (frame !== undefined) window.cancelAnimationFrame(frame);
  });
}
export function disposeHistoryPreview(owner: HTMLElement): void {
  previewDisposers.get(owner)?.(); previewDisposers.delete(owner);
}
